<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
/deep/ .el-tabs__content{height: 855px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @addTab1="addTab1()" @removeTab="removeTab(item.name)" :minor='18'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 李旭
 * 矿业信息地图页面
 */
import {mapState} from 'vuex'
import KyxxAdd from '../../../../static/form/KyxxAdd.vue'
import KyxxTreeAdd from '../../../../static/form/KyxxTreeAdd.vue'
import KyxxLB from '../assembly/KyxxLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
import MineLB from '../assembly/MineLB.vue'
export default {
  components: {
    KyxxAdd,
    KyxxLB,
    ComboBox,
    MineLB,
    KyxxTreeAdd
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '矿业信息地图列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: KyxxLB
      }
      ],
      addobj: {
        title: '添加矿业信息',
        name: '2',
        closable: true,
        content: KyxxAdd
      },
      addobj1: {
        title: '添加树节点',
        name: '3',
        closable: true,
        content: KyxxTreeAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //父组件新增添加Tabs
    addTab1()
    {
      this.editableTabs.push(this.addobj1)
      this.editableTabsValue = this.addobj1.name
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/KyxxMap.vue